<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/judgement/modification/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jianyandanhao')">
            <el-input v-model="yt.conditions.inspectionNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')">
            <yi_dictionary_select :multiple="true" :max="10" :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.conditions.inspectionTypes"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gaipanshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="90 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.modifyTimeStart" :end.sync="yt.conditions.modifyTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
const date = new Date();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();

export default {
  name: "web_quality_management_judgement_modification_record_list",
  data() {
    return {
      columns: [
        {
          label: 'jianyandanhao',
          prop: 'inspectionRecord.inspectionNo',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no',
          width: 130
        },
        {
          label: 'gongxumiaoshu',
          prop: 'woProcedure.procedureDesc',
          width: 130
        },
        {
          label: 'jianyanleixing',
          prop: 'inspectionRecord.inspectionType',
          type: 'dictionary_tag',
          key: 'QUALITY_INSPECTION_TYPE'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'yuanjianyanjielun',
          prop: 'originalStatus',
          type: 'dictionary_tag',
          key: 'QUALITY_INSPECTION_STATUS',
          width: 100
        },
        {
          label: 'gaipanjieguo',
          prop: 'modifyResult',
          type: 'dictionary_tag',
          key: 'QUALITY_INSPECTION_STATUS',
          width: 100
        },
        {
          label: 'gaipanyuanyin',
          prop: 'reason',
          width: 130
        },
        {
          label: 'gaipanren',
          prop: 'modifyByObject.nickname',
          width: 130
        },
        {
          label: 'gaipanshijian',
          prop: 'modifyTime',
          type: 'time',
          width: 230
        },
      ]
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.modifyTimeStart = begin;
      this.yt.conditions.modifyTimeEnd = end;
      this.yt.get(1);
    }, 300);
  },
  methods: {
    clear() {
      this.yt.clear({modifyTimeStart:begin,modifyTimeEnd:end});
    }
  }
}
</script>

<style scoped>

</style>